import React from 'react';
import { Dropdown, SuggestionItem } from '../../atoms/forms/Dropdown';
import './evaluationScoreSelector.module.scss';

type Props = {
  type?: 'primary' | 'secondary' | 'danger' | 'white';
  className?: string;
  value: number;
  onChange: (nextValue: number | null) => void;
  maxScore: number;
};

export const ScoreSelector = ({ onChange, value, maxScore }: Props) => {
  function range(max) {
    return Array.from({ length: max }, (_, i) => i);
  }
  const scores = range(maxScore + 1);

  return (
    <div>
      <Dropdown<number>
        styleName="dropdown"
        showSearch={false}
        clickable={true}
        suggestions={() => scores}
        renderSuggestion={(props) => (
          <SuggestionItem {...props} data-value={props.value}>
            {props.value}
          </SuggestionItem>
        )}
        onSuggestionClick={(value) => {
          onChange(value);
        }}
      >
        {value == null ? '--' : value}
      </Dropdown>
    </div>
  );
};
